import { Component, OnInit } from '@angular/core';
import { first } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Component({
  selector: 'app-logout',
  template: `
<tcc-simplePanel size="small">
  <div panel-header>Logging Out</div>
  <div panel-body>
      <p>You are being logged out.</p>
  </div>
</tcc-simplePanel>
`
})
export class LogoutComponent implements OnInit {

  constructor(private authSvc: AuthService) { }

  ngOnInit() {
    this.authSvc.logout().subscribe();
  }

}
